import { getMerchantList } from '@/api/merchant/merchantList.js'

let state = {
    data: null
};

let getters = {
    getData(state) {
        return state
    }
};

let mutations = {
    setState(state, payload) {
        state.data = payload;
    }
};

let actions = {
    getListAction({ commit, dispatch }, param) {
        //console.log(param)
        getMerchantList({
            'pageNo': param.pageNum,
            'pageSize': 10
        }).then((res) => {
            //console.log(JSON.stringify(res.data,null,4))
            if (res.data){
                commit('setState', res.data)
            }
        }).catch((error) => {
            console.log(error)
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchantlist.js